import { render, staticRenderFns } from "./compalaintList.vue?vue&type=template&id=6f721d62&scoped=true&"
import script from "./compalaintList.vue?vue&type=script&lang=js&"
export * from "./compalaintList.vue?vue&type=script&lang=js&"
import style0 from "./compalaintList.vue?vue&type=style&index=0&id=6f721d62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f721d62",
  null
  
)

export default component.exports